'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var RICH_MEDIA_RETURN_TO_PREVIEW = exports.RICH_MEDIA_RETURN_TO_PREVIEW = 'RICH_MEDIA_RETURN_TO_PREVIEW';
var RICH_MEDIA_EMBEDDING = exports.RICH_MEDIA_EMBEDDING = 'RICH_MEDIA_EMBEDDING';
var RICH_MEDIA_READY = exports.RICH_MEDIA_READY = 'RICH_MEDIA_READY';
var RICH_MEDIA_ERROR = exports.RICH_MEDIA_ERROR = 'RICH_MEDIA_ERROR';

var RICH_MEDIA_STATE = exports.RICH_MEDIA_STATE = {
    PREVIEW: 'PREVIEW',
    EMBEDDING: 'EMBEDDING',
    READY: 'READY',
    ERROR: 'ERROR'
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/richMediaConstants.js
// module id = 304
// module chunks = 0